import LawyerCasesPage from '@/pages/LawyerCasesPage';

export default {
    path: '/lawyer/cases',
    component: LawyerCasesPage,
    name: 'lawyer.cases.index',
}
